/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VccCredentialsV2StateResponse
 */
export interface VccCredentialsV2StateResponse {
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsV2StateResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsV2StateResponse
     */
    errorMessage?: string | null;
}

export function VccCredentialsV2StateResponseFromJSON(json: any): VccCredentialsV2StateResponse {
    return VccCredentialsV2StateResponseFromJSONTyped(json, false);
}

export function VccCredentialsV2StateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VccCredentialsV2StateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function VccCredentialsV2StateResponseToJSON(value?: VccCredentialsV2StateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'errorMessage': value.errorMessage,
    };
}


